<script lang="ts">
    import type { Meeting } from '../firestore';
    import { Row, Col, Tooltip } from 'svelte-materialify/src';
    import { Icon } from 'svelte-materialify';
    import SeatChip from './SeatChip.svelte';

    export let value: Meeting;
    export let showAttendance: boolean = true;
</script>

<Col class="pa-2">
    {#each value.attendees as person (person.identity.email)}
    <Row>
        <Col class="pl-0">
            <b>{person.identity.name}</b>&nbsp;&nbsp;<SeatChip value={person.seat} />
            <div style="line-height: 1.1 !important; font-size: 0.9rem;" class="grey-text text-darken-2">{person.goal}</div>
        </Col>
        {#if showAttendance}
            <div class="float-right mt-auto mb-auto">
                <Tooltip bottom>
                    <Icon class="material-icons">
                        {#if person.present}
                            check_box
                        {:else}
                            check_box_outline_blank
                        {/if}
                    </Icon>
                    <span slot="tip">
                        {#if person.present}
                            {person.identity.name} attended {value.id}
                        {:else}
                            {person.identity.name} did not attend {value.id}
                        {/if}
                    </span>
                </Tooltip>
            </div>
        {/if}
    </Row>
    {:else}
        <i>No members attending</i>
    {/each}
</Col>